import React from 'react'

export default function ButtonWithIcon({title , icon , styles ,link,actions}) {
  return (
    <a className={styles} href={link}> <i className={icon}/>  {title} </a> 
    )
}
